import sciQuiz from './sciQuiz';
import triviaQuiz from './triviaQuiz';
import oopQuiz from './oopQuiz';
import comboQuiz from './comboQuiz';
import movieQuiz from './movieQuiz';

// route all the quizzes here

export { sciQuiz, triviaQuiz, comboQuiz, oopQuiz, movieQuiz };
